import { render, staticRenderFns } from "./otherDjInfo.vue?vue&type=template&id=2a3efb46&scoped=true&"
import script from "./otherDjInfo.vue?vue&type=script&lang=js&"
export * from "./otherDjInfo.vue?vue&type=script&lang=js&"
import style0 from "./otherDjInfo.vue?vue&type=style&index=0&id=2a3efb46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3efb46",
  null
  
)

export default component.exports